import { Grid } from '@mantine/core';

import { BatchesArchivedReport } from './BatchesArchivedReport';
import { DailyReport } from './DailyReport';
import { UnarchiveBatches } from './UnarchiveBatches';

export const B2CReports = () => {
  return (
    <Grid>
      <Grid.Col span={3}>
        <DailyReport title="Daily report B2C" />
      </Grid.Col>
      <Grid.Col span={3} offset={1}>
        <BatchesArchivedReport title="LV Customs report" />
      </Grid.Col>
      <Grid.Col span={3} offset={1}>
        <UnarchiveBatches title="Unarchive batches" />
      </Grid.Col>
    </Grid>
  );
};
